import Popup from 'reactjs-popup';
import styled from 'styled-components';
import Button from 'components/Basic/Button';

const FullScreenOverlay = styled(Popup)`
	&-overlay {
		background: rgba(0, 0, 0, 0.75);
	}
	&-content {
		width: 100vw !important;
		height: 100vh !important;
		max-width: 100vw !important;
		margin: 0 !important;
		padding: 0 !important;
		border-radius: 0 !important;
		border: none !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		background: transparent !important;
		box-shadow: none !important;
	}
`;

const Card = styled.div`
	background: var(--defaultBgColor);
	border-radius: 12px;
	padding: 48px 56px;
	max-width: 560px;
	width: 90%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
`;

const IconWrap = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 4px;
`;

const Title = styled.h3`
	font-size: 1.5rem;
	font-weight: 600;
	color: var(--textHeadingColor);
	margin: 0;
	text-align: center;
`;

const Message = styled.p`
	font-size: 0.95rem;
	line-height: 1.6;
	color: var(--textColor);
	text-align: center;
	margin: 0;
`;

type Props = {
	open: boolean;
	onClose: () => void;
	message: string;
};

export default function BraveWarningModal({ open, onClose, message }: Props) {
	return (
		<FullScreenOverlay open={open} modal closeOnDocumentClick={false} closeOnEscape={false}>
			<Card>
				<IconWrap>
					<svg width="56" height="56" viewBox="0 0 77 77" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M4.27955 47.2561C-0.717624 28.459 10.4876 9.18148 29.2654 4.18431C42.604 0.647853 56.2117 5.26063 64.7453 14.9667" stroke="#FEB517" strokeWidth="5.62873" strokeMiterlimit="10" strokeLinecap="round" />
						<path d="M12.0035 61.6506C11.8885 61.5356 11.7927 61.4015 11.6777 61.2865" stroke="#FEB517" strokeWidth="5.62873" strokeMiterlimit="10" strokeLinecap="round" />
						<path d="M72.3237 29.1875C77.3209 47.9846 66.1157 67.2621 47.3379 72.2593C34.0762 75.7765 20.5646 71.2406 12.0117 61.6499" stroke="#FEB517" strokeWidth="5.62873" strokeMiterlimit="10" strokeLinecap="round" />
						<path d="M65.0316 10.4324C65.4251 9.92738 66.2176 10.0377 66.4583 10.6309L69.0495 17.0192C69.2901 17.6124 68.7983 18.2437 68.1642 18.1555L61.3362 17.2054C60.7021 17.1172 60.4013 16.3756 60.7948 15.8706L65.0316 10.4324Z" fill="#FEB517" />
						<path d="M6.41032 57.3931C6.25603 56.7718 6.83218 56.2164 7.4474 56.3935L14.0724 58.2998C14.6876 58.4769 14.8805 59.2535 14.4196 59.6978L9.45612 64.482C8.9952 64.9263 8.22618 64.705 8.07188 64.0837L6.41032 57.3931Z" fill="#FEB517" />
						<path d="M38.5 22V42M38.5 50V54" stroke="#FEB517" strokeWidth="5.62873" strokeLinecap="round" />
					</svg>
				</IconWrap>
				<Title>Browser Compatibility Warning</Title>
				<Message>{message}</Message>
				<Button autoFocus onClick={onClose} style={{ marginTop: 8, borderColor: 'var(--primary)', minWidth: 120 }}>
					OK, I Understand
				</Button>
			</Card>
		</FullScreenOverlay>
	);
}
